import { all, call, put, takeLatest } from 'typed-redux-saga/macro';
import { DEVICES_URL } from '../../constants/api.constants';
import { apiRequestWrapper } from '../../utils/api/api.utils';
import { setIsError } from '../error/error.action';
import { setIsLoading } from '../loading/loading.action';
import { getDeviceFailed, getDeviceParamsChartDataFailed, GetDeviceParamsChartDataStart, getDeviceParamsChartDataSuccess, GetDeviceStart, getDeviceStatusFailed, GetDeviceStatusStart, getDeviceStatusSuccess, getDeviceSuccess } from './device.action';
import { DEVICE_ACTION_TYPES } from './device.types';


export function* getDevice({
    payload: { deviceId, onComplete },
}: GetDeviceStart) {
    yield* put(setIsLoading(true));
    try {
        let deviceUrl = `${DEVICES_URL}${deviceId}/`;
        const deviceResponse = yield* call(
            apiRequestWrapper, deviceUrl, 'GET', null
        );
        if (deviceResponse) {
            yield* put(getDeviceSuccess());
            onComplete(deviceResponse);
        }
        yield* put(setIsLoading(false));
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getDeviceFailed(errorResponse));
        yield* put(setIsLoading(false));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* getDeviceParamsChartData({
    payload: { deviceId, params, aggregate, from_ts, to_ts, values_format, loading, onComplete },
}: GetDeviceParamsChartDataStart) {
    if (loading) yield* put(setIsLoading(true));
    try {
        const paramsQueryString = `?parameters=${params.join(',')}`;
        const aggregateQueryString = `&aggregate=${aggregate}`;
        const fromTsQueryString = `&from_ts=${from_ts}`;
        const toTsQueryString = `&to_ts=${to_ts}`;
        const valuesFormatQueryString = values_format ? `&values_format=${values_format}` : '';

        let deviceParamsUrl = `${DEVICES_URL}${deviceId}/values/${paramsQueryString}${aggregateQueryString}${fromTsQueryString}${toTsQueryString}${valuesFormatQueryString}`;
        const deviceParamsResponse = yield* call(
            apiRequestWrapper, deviceParamsUrl, 'GET', null
        );
        if (deviceParamsResponse) {
            yield* put(getDeviceParamsChartDataSuccess());
            onComplete(deviceParamsResponse);
        }
        if (loading) yield* put(setIsLoading(false));
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getDeviceParamsChartDataFailed(errorResponse));
        if (loading) yield* put(setIsLoading(false));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* getDeviceStatus({
    payload: { deviceId, onComplete },
}: GetDeviceStatusStart) {
    try {
        let deviceUrl = `${DEVICES_URL}${deviceId}/status/`;
        const statusResponse = yield* call(
            apiRequestWrapper, deviceUrl, 'GET', null
        );
        if (statusResponse) {
            yield* put(getDeviceStatusSuccess());
            onComplete(statusResponse);
        }
    } catch (error: any) {
        const errorResponse = error.response?.data?.error_description ??
            error.response?.data?.error ?? error.response?.data?.detail ?? error.message ?? 'Errore server';
        yield* put(getDeviceStatusFailed(errorResponse));
        yield* put(setIsError(true, errorResponse));
    }
}

export function* onGetDeviceStart() {
    yield* takeLatest(DEVICE_ACTION_TYPES.GET_DEVICE_START, getDevice);
}

export function* onGetDeviceParamsChartDataStart() {
    yield* takeLatest(DEVICE_ACTION_TYPES.GET_DEVICE_PARAMS_CHART_DATA_START, getDeviceParamsChartData);
}

export function* onGetDeviceStatusStart() {
    yield* takeLatest(DEVICE_ACTION_TYPES.GET_DEVICE_STATUS_START, getDeviceStatus);
}

export function* deviceSaga() {
    yield* all([
        call(onGetDeviceStart),
        call(onGetDeviceParamsChartDataStart),
        call(onGetDeviceStatusStart),
    ]);
}
